import { Card } from "antd";
import "./styles.css";
import clsx from "clsx";
import { useMemo } from "react";

export const MultiSelectTitleCardsList = ({
  options,
  selectedOptions,
  setSelectedOptions,
}) => {
  return options.map((option) => {
    const value = option.value ?? option.title;
    return (
      <SmallTitleCard
        key={value}
        title={option.title}
        value={value}
        selectedOptions={selectedOptions}
        setSelectedOptions={setSelectedOptions}
      />
    );
  });
};

export const SmallTitleCard = ({
  title,
  value,
  selectedOptions,
  setSelectedOptions,
}) => {
  const isPresentInSelectedOptions = useMemo(() => {
    return selectedOptions?.includes(value);
  }, [selectedOptions, value]);
  return (
    <Card
      className={clsx(
        "multi-select-title-card",
        selectedOptions?.includes(value) && "multi-select-title-card-selected"
      )}
      hoverable
      onClick={() => {
        if (isPresentInSelectedOptions) {
          setSelectedOptions(
            selectedOptions.filter((option) => option !== value)
          );
        } else {
          setSelectedOptions([...selectedOptions, value]);
        }
      }}
    >
      <p className="multi-select-title-card-title">{title}</p>
    </Card>
  );
};
